import React from "react";

const PriceMatrixTable = ({
  packSizeOptions = [],
  packBagOptions = [],
  values,
  setValues,
  formValues
}) => {
 const handleChange = (bag, size, price) => {
  setValues((prev) => {
    const index = prev.findIndex(
      (item) =>
        item.packBag_id === bag.value &&
        item.packSize_id === size.value
    );

    const newRecord = {
  packBag_id: bag.value,
  packSize_id: size.value,
  price: price === "" ? "" : Number(price),
};

    if (index > -1) {
      const copy = [...prev];

      if (price === "") {
        copy.splice(index, 1);
        return copy;
      }

      copy[index] = newRecord;
      return copy;
    }

    if (price === "") return prev;

    return [...prev, newRecord];
  });
};

const getValue = (bagId, sizeId) => {
  const item = values.find(
    (x) =>
      x.packBag_id === bagId &&
      x.packSize_id === sizeId
  );

  return item ? item.price : "";
};

  return (
  <div className="price-card mt-5">
 <h4 className="text-center">All prices are in US Dollars</h4>

  <div className="table-responsive">
    <table className="price-table">
      <thead>
        <tr>
          <th className="sticky-col">Bag Type</th>

          {packSizeOptions.map((size) => (
            <th key={size.value}>{size.label}</th>
          ))}
        </tr>
      </thead>

      <tbody>
        {packBagOptions.map((bag) => (
          <tr key={bag.value}>
            <td className="sticky-col bag-title">
              {bag.label}
            </td>

            {packSizeOptions.map((size) => (
              <td key={size.value}>
               <input
  type="number"
  placeholder="0.00"
  className="price-input"
  value={getValue(bag.value, size.value)}
  onChange={(e) =>
    handleChange(
      bag,
      size,
      e.target.value
    )
  }
/>
              </td>
            ))}
          </tr>
        ))}
      </tbody>
    </table>
  </div>
</div>
  );
};

export default PriceMatrixTable;